import React, { useRef } from "react";
import PubSub from "pubsub-js";
// import Pre from "../ui/Pre";

const Variations = ({ input }) => {
  const { label, variations, index } = input;
  const variationsRef = useRef();

  const variationChange = e => {
    // console.log(e.target);
    const value = variations.filter(item => item.option === e.target.value)[0];
    // console.log(value);
    PubSub.publish("VARIATION_CHANGE", {
      label: label,
      index: index,
      value: value.option,
      price: value.price
      // price: e.target.dataset.option
    });
  };
  // const variationReset = el => {
  //   PubSub.publish("VARIATION_RESET");
  // };

  return (
    <div className='variations ' ref={variationsRef}>
      {/* <Pre input={variations} /> */}
      <select name={label} onChange={e => variationChange(e)}>
        <option value=''>{label}</option>

        {variations.map((el, i) => (
          <option key={i} value={el.option}>
            {el.option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Variations;
